// The only two signing roles this account uses. Upstream ships an open-ended
// "First Party".."100th Party" list; here ApTask always sends and the employee always signs.
// Mirrored server-side by Template::SIGNER_ROLE_NAMES, which EnvelopesController's role
// defaults read from — change one and change the other.
//
// Shared by field_submitter.vue (the builder's Recipients dropdown, where names.length is also
// what caps the builder at two recipients) and the EnvelopeCreator/TemplateCreator modals.
// Its own module rather than an export from the .vue, so the JSX creators can import it
// without pulling a whole SFC through vue-loader.
export const SIGNER_ROLE_NAMES = ['ApTask Onboarding', 'Employee']

// A role is not a person: the role lives in `name`, and these are the prefill for whoever
// usually fills it. ApTask's onboarding mailbox is always the same address; the employee is
// different every time, so only the first role has an entry here.
export const ROLE_DEFAULTS = {
  'ApTask Onboarding': { default_name: 'ApTask Onboarding', email: 'onboarding@aptask.com' }
}

// The role for recipient `index`, for the rows past the two named ones (extra recipients are
// possible in the envelope creator even though the builder itself stops at two). Matches
// EnvelopesController#default_role_name.
export function defaultRoleName (index) {
  return SIGNER_ROLE_NAMES[index] || `Signer ${index + 1}`
}
